<script>
	export let data = {};
</script>

<h3 class="UIHeading _{data.style}">
	{@html data.text.split("\n").join("<br>")}
</h3>

<style global>
	.UIHeading {
		padding: 1.25em 0;
		font-weight: bold;
		font-size: 1.5em;
		color: #524e4e;
		text-align: center;
	}
	.UIHeading._frame {
		text-align: left;
		padding: 1em;
		margin: 3em 0;
		font-weight: normal;
		font-size: 1.2em;
		color: #524e4e;
		background: #efefef;
	}
	.UIHeading._program {
		padding: 2em 0;
		font-weight: bold;
		font-size: 1.75em;
		color: #61788c;
	}
</style>
